import { render, staticRenderFns } from "./generateCourse.vue?vue&type=template&id=117bd958&scoped=true&"
import script from "./generateCourse.vue?vue&type=script&lang=js&"
export * from "./generateCourse.vue?vue&type=script&lang=js&"
import style0 from "./generateCourse.vue?vue&type=style&index=0&id=117bd958&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117bd958",
  null
  
)

export default component.exports